import React, { CSSProperties, ReactNode } from 'react'
import './DetailRowItem.css'

const DetailRowItem = ({
    children,
    style
}: {
    children: ReactNode,
    style?: CSSProperties
}) => {
    return (
        <div className='detail-row__item' style={style}>{children}</div>
    )
}

export default DetailRowItem